import { render, staticRenderFns } from "./Legs.vue?vue&type=template&id=39a48c2e&scoped=true&"
import script from "./Legs.vue?vue&type=script&lang=js&"
export * from "./Legs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a48c2e",
  null
  
)

export default component.exports